/**
 * Environment configuration for the frontend
 * This file provides access to environment variables and configuration
 */

// Get the production domain from environment or use default
export const getProductionDomain = (): string => {
  // In production, this would come from build-time environment variables
  // For now, we'll use a default that can be overridden
  return process.env.REACT_APP_PRODUCTION_DOMAIN || 'arm.kuleyev.tech';
};

// Check if current hostname matches production domain
export const isProductionDomain = (): boolean => {
  return window.location.hostname === getProductionDomain();
};

// Check if we're in production environment
export const isProduction = (): boolean => {
  return process.env.NODE_ENV === 'production' || isProductionDomain();
};

// Get current environment
export const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};

// Configuration object
export const config = {
  productionDomain: getProductionDomain(),
  isProduction: isProduction(),
  isProductionDomain: isProductionDomain(),
  environment: getEnvironment(),
};
